export default __webpack_public_path__ + "static/media/dunlop-australian-open.7d42b3eb.jpg";